import { MenuItem } from '@app/models';
import { AuthenticationService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MyMenu {
  constructor(
    public translate: TranslateService,
    private authenticationService: AuthenticationService
  ) { }

  getMenu(received, sent): MenuItem[] {
      return [
        //MAIN
        {
          label: this.translate.instant(`Main`),
          isTitle: true,
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`Dashboard`),
          icon: 'fa fa-home',
          link: '/dashboard',
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        //DOMAINS
        {
          label: this.translate.instant(`Domains`),
          isTitle: true
        },
        {
          label: this.translate.instant(`Catalogue`),
          icon: 'fa fa-search',
          link: '/domains/sites',
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`Wishlist`),
          icon: 'fa fa-bookmark',
          link: '/domains/wishlist',
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`My sites`),
          icon: 'fa fa-list',
          link: '/domains/mysites',
        },
        //DEALS
        {
          label: this.translate.instant(`Deals`),
          isTitle: true,
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`Received proposals`),
          icon: 'fa fa-download',
          link: '/deals/proposals/table-receivedpropositions',
          badge: {
            variant: 'danger',
            text: received,
          },
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`Sent proposals`),
          icon: 'fa fa-upload',
          link: '/deals/proposals/table-sentpropositions',
          badge: {
            variant: 'danger',
            text: sent,
          },
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        //REFERRAL
        {
          label: this.translate.instant(`Referral`),
          isTitle: true,
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        {
          label: this.translate.instant(`Referral Code`),
          icon: 'fa fa-share-alt',
          link: '/general/referral',
          highlight: {
            styleClass: 'contest',
          },
          isLocked: this.authenticationService.isDealer() || this.authenticationService.isAdmin()
        },
        //GUIDE
        {
          label: this.translate.instant(`Get started`),
          isTitle: true,
        },
        {
          label: this.translate.instant(`Start-up Guide`),
          icon: 'fa fa-question-circle',
          link: '/general/guide'
        },
        //ADMIN
        {
          label: 'Admin',
          isTitle: true,
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Membres',
          icon: 'fa fa-users',
          link: '/admin/table-members',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Domaines',
          icon: 'la la-list',
          link: '/admin/table-domaines',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Propositions',
          icon: 'las la-handshake',
          link: '/admin/table-propositions',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Parrainages',
          icon: 'la la-award',
          link: '/admin/table-parrainages',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Evaluations',
          icon: 'fa fa-thumbs-up',
          link: '/admin/table-evaluations',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Support',
          icon: 'las la-comments',
          link: '/admin/table-support',
          isLocked: this.authenticationService.isSupport()
        },
        {
          label: 'Logs',
          icon: 'la la-file-alt',
          link: '/admin/table-logs',
          isLocked: this.authenticationService.isAdmin()
        },
        {
          label: 'Mails',
          icon: 'fa fa-envelope-o',
          link: '/admin/table-notifications',
          isLocked: this.authenticationService.isAdmin()
        },
      ];
  }
}
